/* eslint-disable i18next/no-literal-string */

/**
 * Ported from bouncieweb's
 * `LandingPageComponents/ActiveTripExample/AnimatedSpeeds.js`.
 *
 * An odometer-style two-digit readout. Each column is a stacked 0-9 list; a
 * negative top-margin (`-${digit}em`) scrolls the requested digit into the 1em
 * viewport, and the transition animates the roll. A top/bottom fade mask softens
 * the edges.
 */

function DigitColumn({ number }: { number: number }) {
  return (
    <div
      className="inline-block transition-all duration-[0.75s] ease-out"
      style={{ marginTop: `-${number}em` }}
    >
      {Array.from({ length: 10 }, (_, i) => (
        <div key={i}>{i}</div>
      ))}
    </div>
  );
}

export default function AnimatedSpeeds({
  tens,
  ones,
}: {
  tens: number;
  ones: number;
}) {
  return (
    <div
      className="flex h-[1em] overflow-hidden"
      style={{
        maskImage:
          "linear-gradient(to bottom, transparent 0%, black 20% 80%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(to bottom, transparent 0%, black 20% 80%, transparent 100%)",
      }}
    >
      <DigitColumn number={tens} />
      <DigitColumn number={ones} />
    </div>
  );
}
